import { useMutation } from "react-query";
import { submitDeposit } from "./gateway";
import { useNavigate } from "react-router-dom";

export const useSubmitDeposit = (
  mode: "certificate" | "subscription" | "application" | "violationCase",
) => {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: submitDeposit,
    mutationKey: "submitDeposit",
    onSuccess: () => {
      navigate("/payment/depositSuccess", { state: { mode: mode } });
    },
  });
};
